// Centralized TanStack Query keys. One per resource so invalidation stays sane.
export const qk = {
  profile: ['profile'] as const,
  beneficiaries: ['beneficiaries'] as const,
  rates: ['rates'] as const,
  transfers: (filters?: Record<string, unknown>) => ['transfers', filters ?? {}] as const,
  transfer: (id: string) => ['transfers', id] as const,
  kycStatus: ['kyc', 'status'] as const,
  settings: ['settings'] as const,
};
